/**
 * 保养工单
 */
import { MAINTENANCEWORKORDER } from '../types';

export default {
    name: `${MAINTENANCEWORKORDER}`,
    path: '/maintenanceWorkOrder',
    component: () => import(/* webpackChunkName: 'maintenanceWorkOrder' */ '@/views/workOrderMaintenance/'),
    redirect: { name: `${MAINTENANCEWORKORDER}Index` },
    meta: {
        title: '保养工单',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${MAINTENANCEWORKORDER}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'maintenanceWorkOrder' */ '@/views/workOrderMaintenance/home/Home.vue'),
        },
        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${MAINTENANCEWORKORDER}Create`,
            path: 'create',
            component: () => import(/* webpackChunkName: 'maintenanceWorkOrder' */ '@/views/workOrderMaintenance/add/Add.vue'),
        },
        {
            name: `${MAINTENANCEWORKORDER}Detail`,
            path: 'detail',
            component: () => import(/* webpackChunkName: 'maintenanceWorkOrder' */ '@/views/workOrderMaintenance/detail/Detail.vue'),
        },
    ],
};
